import React, { Component } from 'react'
import { routerActions } from 'connected-react-router'
import { withRouter, Switch, Route } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Container, Dimmer, Loader } from 'semantic-ui-react'
import AppHeader from '../components/AppHeader'
import * as Events from '../store/Events'
import * as Config from '../store/Config'
import FacilitySelection from '../components/FacilitySelection'
import ReservationInfo from '../components/ReservationInfo'
import ReservationReview from '../components/ReservationReview'
import ReservationPage from './ReservationPage'
import moment from 'moment'

class EventPage extends Component {
    constructor(props) {
        super(props)
        this.state = {
            stateBlocks: [],
            selectedFacility: null,
            spots: 1,
            parker: {},
            additionalInfo: {},
            confirmation: '',
            loading: false,
        }
        this.onDateSelect = this.onDateSelect.bind(this)
        this.onFacilitySelect = this.onFacilitySelect.bind(this)
        this.onChange = this.onChange.bind(this)
        this.inventory = this.inventory.bind(this)
        this.onCreateReservation = this.onCreateReservation.bind(this)
        this.onParkerChange = this.onParkerChange.bind(this)
        this.onAdditionalInfoChange = this.onAdditionalInfoChange.bind(this)
        this.onSubmitReservation = this.onSubmitReservation.bind(this)
        this.onReview = this.onReview.bind(this)
    }

    async componentDidMount() {
        const { actions, slug } = this.props
        const { stateBlocks } = this.state
        try {
            await actions.getConfig()
            var result = await actions.getEvent(slug)
            if (moment(result.finish) < moment()) {
                window.location = '/'
            }
            const { blocks } = result.response

            if (!stateBlocks.length) {
                this.setState({ stateBlocks: [...blocks] })
            }
        } catch (error) {
            window.location = '/'
        }
    }

    onDateSelect(e, { block }) {
        const { stateBlocks } = this.state
        block.selected = !block.selected
        this.setState({ stateBlocks: [...stateBlocks.filter((d) => d.id !== block.id), block] })
    }
    onFacilitySelect(e, { rate, facility }) {
        this.setState({ selectedFacility: { ...facility, rate } })
    }
    onChange(e, { name, value }) {
        this.setState({ [name]: value })
    }
    onCreateReservation(e) {
        const { actions, slug } = this.props
        this.setState({ error: null })
        actions.push(`/${slug}/information`)
    }
    onParkerChange(e, { name, value }) {
        const { parker } = this.state
        this.setState({ parker: { ...parker, [name]: value } })
    }
    onAdditionalInfoChange(e, { name, value }) {
        const { additionalInfo } = this.state
        this.setState({ additionalInfo: { ...additionalInfo, [name]: value } })
    }
    onReview(e) {
        const { actions, slug } = this.props
        actions.push(`/${slug}/review`)
    }
    async onSubmitReservation(e) {
        this.setState({ loading: true })
        console.log('onSubmitReservation')
        const { actions, event } = this.props
        const { parker, selectedFacility, additionalInfo, spots, stateBlocks } = this.state
        const { inventoryId } = selectedFacility
        const inventory = event.inventory.find((i) => i.id === inventoryId)
        const selected = stateBlocks.filter((d) => d.selected)
        const selectedBlocks = inventory.blocks.filter((b) => selected.find((sb) => sb.id === b.eventBlockId)).map((ib) => ({ inventoryBlockId: ib.id }))
        const reservation = { inventoryId, ...parker, spots, additionalInformation: JSON.stringify(additionalInfo), blocks: selectedBlocks } //token: parker.token.id
        console.log('reservation', reservation)
        try {
            var result = await actions.createReservation(reservation)
            console.log('result', result)
            window.location = result.response.checkoutSessionUrl
            // this.setState({ confirmation: result.response.number })
            // this.setState({ loading: false })
        } catch (error) {
            console.log('error', error)
            this.setState({ error: error.message, loading: false })
        }
    }
    inventory() {
        const { event } = this.props
        const { stateBlocks, spots } = this.state
        const { inventory } = event
        const selected = stateBlocks.filter((d) => d.selected)
        if (spots < 1) return []
        return inventory
            .filter((i) => {
                if (!selected.length) return false
                // const idays = i.days.map(d => ({spots: d.spots, day: moment.utc(d.day)})).filter(d => selected.find(sd => sd.isSame(d.day)));
                const iblocks = i.blocks.filter((b) => selected.find((sb) => sb.id === b.eventBlockId))
                let isMatch = true
                iblocks.forEach((block) => {
                    isMatch = isMatch && spots <= block.spots
                })
                return isMatch
            })
            .map((i) => {
                const iblocks = i.blocks.filter((b) => selected.find((sb) => sb.id === b.eventBlockId))
                const rate = iblocks.reduce((a, b) => ({ rate: a.rate + b.rate }))
                return { ...i, rate: rate.rate }
            })
    }
    render() {
        const { event, config } = this.props
        const { spots, stateBlocks, selectedFacility, parker, additionalInfo, confirmation, error, loading } = this.state
        if (!event) {
            return (
                <div className="app">
                    <AppHeader />
                    <Container>
                        <Dimmer active={!event}>
                            <Loader />
                        </Dimmer>
                    </Container>
                </div>
            )
        }

        if (moment(event.finish) < moment()) {
            window.location = '/'
        }

        const { venue } = event

        const sortBlocks = (a, b) => moment.utc(a.startDate) - moment.utc(b.startDate) || moment.utc(b.endDate) - moment.utc(a.endDate)

        return (
            <div className="app">
                <AppHeader />
                <div className="bigimage"></div>
                <Switch>
                    <Route
                        path="/:event/information"
                        render={() => (
                            <ReservationInfo
                                event={event}
                                spots={spots}
                                //  days={days.filter(d => d.selected).map(d => d.dt)}
                                blocks={stateBlocks.sort(sortBlocks).filter((b) => b.selected)}
                                selectedFacility={selectedFacility}
                                parker={parker}
                                onChange={this.onParkerChange}
                                additionalInfo={additionalInfo}
                                onAdditionalInfoChange={this.onAdditionalInfoChange}
                                onSubmitReservation={this.onReview}
                                publishKey={config.stripePublishKey}
                            />
                        )}
                    />
                    <Route
                        path="/:event/review"
                        render={() => (
                            <ReservationReview
                                confirmation={confirmation}
                                event={event}
                                spots={spots}
                                blocks={stateBlocks.sort(sortBlocks).filter((b) => b.selected)}
                                // days={days.filter(d => d.selected).map(d => d.dt)}
                                selectedFacility={selectedFacility}
                                parker={parker}
                                additionalInfo={additionalInfo}
                                onSubmit={this.onSubmitReservation}
                                onEdit={this.onCreateReservation}
                                loading={loading}
                                error={error}
                            />
                        )}
                    />
                    <Route path="/:event/:confirmationNumber/confirmation" component={ReservationPage} />
                    <Route path="/:event/:confirmationNumber" render={() => <ReservationPage onSubmit={this.onSubmitReservation} />} />
                    <Route
                        path="/:event"
                        render={() => (
                            <FacilitySelection
                                event={event}
                                // days={days}
                                blocks={stateBlocks.sort(sortBlocks)}
                                onDateSelect={this.onDateSelect}
                                spots={spots}
                                onChange={this.onChange}
                                inventory={this.inventory}
                                selectedFacility={selectedFacility}
                                onFacilitySelect={this.onFacilitySelect}
                                venue={venue}
                                onCreateReservation={this.onCreateReservation}
                            />
                        )}
                    />
                </Switch>
                <div style={{ display: 'flex', marginTop: 25, justifyContent: 'center' }}>
                    <a rel="noopener noreferrer" href="https://s3.us-east-2.amazonaws.com/denisonparking-static/FAQ.pdf" target="_blank">
                        F.A.Q.
                    </a>
                </div>
            </div>
        )
    }
}

EventPage.propTypes = {}

const mapStateToProps = (state, ownProps) => {
    return {
        config: Config.selector(state),
        event: Object.values(Events.selector(state).events).find((e) => e.slug === ownProps.match.params.event.toLowerCase()),
        slug: ownProps.match.params.event.toLowerCase(),
    }
}

const mapDispatchToProps = (dispatch) => ({
    actions: {
        ...bindActionCreators(Config.actionCreators, dispatch),
        ...bindActionCreators(Events.actionCreators, dispatch),
        ...bindActionCreators(routerActions, dispatch),
    },
})

export default withRouter(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(EventPage)
)
